import React from 'react';
import { UserMessage } from '../LiliUserMessage/UserMessage';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../LiliCloseButton/CloseButton';
import { LiliButton, type LiliButtonProps, LiliButtonType } from '../LiliButton/LiliButton';
import { FontWeight, Heading } from '../../tokens';

export interface NoticeModalProps {
  title?: string;
  onClickOutside?: () => void;
  id: string;
  image?: React.ReactNode;
  content: React.ReactNode;
  buttonText: string;
  secondaryButtonText?: string;
  onSubmit: () => void;
  secondaryOnSubmit?: () => void;
  isButtonLoading?: boolean;
  submitButtonProps?: Partial<LiliButtonProps>;
  SvgComponent?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  shouldPersist?: boolean;
  blur?: boolean;
}

export const NoticeModal = (props: NoticeModalProps) => {
  const {
    title,
    onClickOutside = () => {},
    id,
    image,
    buttonText,
    secondaryButtonText,
    onSubmit,
    secondaryOnSubmit,
    isButtonLoading,
    content,
    submitButtonProps,
    SvgComponent,
    shouldPersist,
    blur = true,
  } = props;
  return (
    <UserMessage
      onClick={onClickOutside}
      id={id}
      shouldPersist={shouldPersist}
      blur={blur}
      contentWrapperClassName='p-[16px]'>
      <div className='flex flex-col rounded-[12px] bg-surface-primary-bw-01 w-full max-w-[468px] px-[24px]'>
        <div className='text-center flex justify-center items-center mb-[16px] mt-[40px]'>
          {image && <div className='flex items-center'>{image}</div>}
          {SvgComponent && (
            <div className='flex items-center '>
              <SvgComponent />
            </div>
          )}
          {!shouldPersist && (
            <div className='absolute top-8 right-8'>
              <CloseButton
                size={CloseButtonSize.Medium}
                id='close-modal'
                color={CloseButtonColor.Gray}
                onClick={onClickOutside}
                circle
              />
            </div>
          )}
        </div>
        {title && (
          <Heading.H7 fontWeight={FontWeight.SEMIBOLD} className='text-center' id='title'>
            {title}
          </Heading.H7>
        )}
        <div className='flex flex-col justify-between'>
          {content}

          <div className='flex flex-col md:!flex-row justify-center gap-[14px] mb-[40px]'>
            {secondaryButtonText && (
              <LiliButton
                title={secondaryButtonText}
                id='cancel'
                onClick={secondaryOnSubmit ?? onClickOutside}
                className='h-[44px] text-[14px]'
                type={LiliButtonType.SECONDARY}
              />
            )}
            <LiliButton
              title={buttonText}
              id='continue'
              onClick={onSubmit}
              isLoading={isButtonLoading}
              className='h-[44px] text-[14px]'
              {...submitButtonProps}
            />
          </div>
        </div>
      </div>
    </UserMessage>
  );
};
